/**************************************************
 * Nombre:       Tarjeta_Estado_Pedido
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {formatoFecha} from "../../Modulo_Carrito_Compra/Utilidades/formatoFecha";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import Pdf_Recibo from "../../Modulo_Wompi/Pdfs/Pdf_Recibo";
import {PDFDownloadLink} from "@react-pdf/renderer";
import logo from '../../Recursos/logo_color.png'

const Tarjeta_Estado_Pedido = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-end'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                border: 1,
                borderColor: '#00000050',
                p: 2,
                color: '#000',
                borderRadius: 4
            }}
        >

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 18, fontWeight: 700, lineHeight: 1.1}}>Estado de pago</Typography>
            </Grid>

            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end', mt: 0}}>
                <Typography sx={{fontSize: 14, fontWeight: 400}}>{`Pedido # ${item.consecutivo}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -0.3}}>
                <Typography sx={{fontSize: 12}}>{`Fecha de Pago: ${formatoFecha(item.fecha)}`}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 12}}> <span style={{fontWeight: 600}}>Nombre Pagador: </span>{item.nombre}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Typography sx={{fontSize: 12}}> <span style={{fontWeight: 600}}>Metodo de Pago: </span>{item.metodo}
                </Typography>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 6, sm: 6, md: 6}}
                sx={{mt: 1}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                    <Typography sx={{fontSize: 12, fontWeight: 600}}>Valor a pagar</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography
                        sx={{fontSize: 18, fontWeight: 700, lineHeight: 1.1}}>{formatoMoneda(item.valor)}</Typography>
                </Grid>

            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 6, sm: 6, md: 6}}
                sx={{mt: 1}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start',}}>
                    <Typography sx={{fontSize: 12, fontWeight: 600}}>Estado de pago</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 18, fontWeight: 700, lineHeight: 1.1}}>{item.estadoPago}</Typography>
                </Grid>

            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 1}}>
                <Typography sx={{fontSize: 12}}> <span style={{fontWeight: 600}}>Mensaje: </span>{item.mensaje}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <PDFDownloadLink document={<Pdf_Recibo logo={logo} datos={item} pedido={item}/>}
                                 fileName={"Comprobante de compra " + item.consecutivo}
                                 style={{textDecoration: "none", width: "100%"}}>
                    <Button fullWidth sx={{p: 1}}> Decargar Recibo</Button>
                </PDFDownloadLink>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Estado_Pedido    